// Quick Variant Popup — выбор варианта из карточки каталога.
// Кнопка [data-or-qvp-open] в карточке (product-card-02) открывает попап;
// данные вариантов лежат рядом в <script type="application/json" data-or-qvp-data>.
// Плитки внутри попапа переиспользуют классы PDP-тайлов (product-variant-tiles.css).
// Добавление в корзину — /cart/add.js c properties[Variant] = full_title (если заполнен),
// как на странице товара (см. or-variant-system.js / план Этап 3).
(function () {
    'use strict';

    if (window.orQvpInitialized) return;
    window.orQvpInitialized = true;

    var backdrop = null;
    var popup = null;
    var currentData = null;
    var selectedVariantId = null;
    var adding = false;

    function escapeHtml(value) {
        return String(value == null ? '' : value)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function ensurePopup() {
        if (popup) return;

        backdrop = document.createElement('div');
        backdrop.className = 'or-qvp-backdrop';

        popup = document.createElement('div');
        popup.className = 'or-qvp';
        popup.setAttribute('role', 'dialog');
        popup.setAttribute('aria-modal', 'true');
        popup.innerHTML =
            '<div class="or-qvp__header">' +
                '<img class="or-qvp__image" src="" alt="">' +
                '<h3 class="or-qvp__title"></h3>' +
                '<button type="button" class="or-qvp__close" aria-label="Close">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">' +
                        '<line x1="5" y1="5" x2="19" y2="19"></line><line x1="19" y1="5" x2="5" y2="19"></line>' +
                    '</svg>' +
                '</button>' +
            '</div>' +
            '<div class="or-qvp__body">' +
                '<p class="or-qvp__label">Select <span class="or-qvp__label-option"></span>: <span class="or-qvp__label-value"></span></p>' +
                '<div class="or-qvp__grid"></div>' +
                '<p class="or-qvp__error">Failed to add to cart. Please try again.</p>' +
            '</div>' +
            '<div class="or-qvp__footer">' +
                '<button type="button" class="or-qvp__add">Add to Cart</button>' +
                '<a class="or-qvp__details" href="#">View Full Details</a>' +
            '</div>';

        document.body.appendChild(backdrop);
        document.body.appendChild(popup);

        backdrop.addEventListener('click', closePopup);
        popup.querySelector('.or-qvp__close').addEventListener('click', closePopup);
        popup.querySelector('.or-qvp__add').addEventListener('click', addToCart);

        popup.querySelector('.or-qvp__grid').addEventListener('click', function (e) {
            var tile = e.target.closest('.organo-republic-variant-tile');
            if (!tile || tile.classList.contains('is-soldout')) return;
            selectVariant(tile.getAttribute('data-variant-id'));
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && popup.classList.contains('is-active')) closePopup();
        });
    }

    function findVariant(id) {
        if (!currentData) return null;
        for (var i = 0; i < currentData.variants.length; i++) {
            if (String(currentData.variants[i].id) === String(id)) return currentData.variants[i];
        }
        return null;
    }

    function selectVariant(id) {
        selectedVariantId = id;
        var variant = findVariant(id);

        popup.querySelectorAll('.organo-republic-variant-tile').forEach(function (tile) {
            tile.classList.toggle('is-selected', String(tile.getAttribute('data-variant-id')) === String(id));
        });

        popup.querySelector('.or-qvp__label-value').textContent = variant ? variant.title : '';

        // Фото и полное имя выбранного варианта в шапке попапа
        var headerImg = popup.querySelector('.or-qvp__image');
        if (headerImg) headerImg.src = (variant && variant.image) || (currentData && currentData.image) || '';
        var headerTitle = popup.querySelector('.or-qvp__title');
        if (headerTitle && currentData) headerTitle.textContent = (variant && variant.fullTitle) || currentData.productTitle || '';

        var addBtn = popup.querySelector('.or-qvp__add');
        addBtn.disabled = !variant || !variant.available;
        if (variant && !variant.available) {
            addBtn.textContent = 'Out of Stock';
        } else if (variant && variant.priceText) {
            // Цена выбранного варианта прямо на кнопке — меньше сомнений перед кликом
            addBtn.textContent = 'Add to Cart — ' + variant.priceText;
        } else {
            addBtn.textContent = 'Add to Cart';
        }

        // Ссылка на страницу товара с выбранным вариантом
        var details = popup.querySelector('.or-qvp__details');
        if (details) {
            var baseUrl = (currentData && currentData.url) || '';
            if (baseUrl) {
                details.style.display = '';
                details.href = variant
                    ? baseUrl + (baseUrl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + variant.id
                    : baseUrl;
            } else {
                details.style.display = 'none';
            }
        }
    }

    function renderTiles() {
        var grid = popup.querySelector('.or-qvp__grid');
        var html = '';

        currentData.variants.forEach(function (v) {
            html +=
                '<button type="button" class="organo-republic-variant-tile or-qvp-tile' + (v.available ? '' : ' is-soldout') + '"' +
                    ' data-variant-id="' + escapeHtml(v.id) + '"' + (v.available ? '' : ' disabled') + '>' +
                    // Фото варианта (variant.image / первое фото variant_gallery) — из or-qvp-data.liquid
                    (v.image ? '<span class="or-qvp-tile__imgwrap"><img class="or-qvp-tile__img" src="' + escapeHtml(v.image) + '" alt="' + escapeHtml(v.title) + '" loading="lazy"></span>' : '') +
                    '<span class="organo-republic-variant-tile__check"></span>' +
                    '<span class="organo-republic-variant-tile__title">' + escapeHtml(v.title) + '</span>' +
                    '<span class="organo-republic-variant-tile__price">' + v.priceText +
                        (v.comparePriceText ? ' <s class="or-qvp-tile__compare">' + v.comparePriceText + '</s>' : '') +
                    '</span>' +
                    (v.savePct ? '<span class="organo-republic-variant-tile__save">Save ' + escapeHtml(v.savePct) + '%</span>' : '') +
                    (v.available ? '' : '<span class="organo-republic-variant-tile__soldout">Sold Out</span>') +
                '</button>';
        });

        grid.innerHTML = html;
    }

    function openPopup(data) {
        ensurePopup();
        currentData = data;

        popup.querySelector('.or-qvp__image').src = data.image || '';
        popup.querySelector('.or-qvp__image').alt = data.productTitle || '';
        popup.querySelector('.or-qvp__title').textContent = data.productTitle || '';
        popup.querySelector('.or-qvp__label-option').textContent = data.optionName || 'Option';
        popup.querySelector('.or-qvp__error').classList.remove('is-visible');

        renderTiles();

        // По умолчанию — первый доступный вариант
        var first = null;
        for (var i = 0; i < data.variants.length; i++) {
            if (data.variants[i].available) { first = data.variants[i]; break; }
        }
        selectVariant(first ? first.id : null);

        backdrop.classList.add('is-active');
        popup.classList.add('is-active');
        document.documentElement.classList.add('or-qvp-open');
    }

    function closePopup() {
        if (!popup) return;
        backdrop.classList.remove('is-active');
        popup.classList.remove('is-active');
        document.documentElement.classList.remove('or-qvp-open');
        currentData = null;
        selectedVariantId = null;
    }

    function showError(message) {
        var el = popup.querySelector('.or-qvp__error');
        el.textContent = message || 'Failed to add to cart. Please try again.';
        el.classList.add('is-visible');
    }

    // Превентивная проверка остатков: maxQty из JSON карточки (null = не отслеживается),
    // текущее количество в корзине — из /cart.js. Как OrgoValidateAdd на PDP.
    function validateStock(variant, qty) {
        if (variant.maxQty == null) return Promise.resolve({ ok: true });
        if (variant.maxQty <= 0) return Promise.resolve({ ok: false, message: 'Sorry, this option is sold out.' });
        return fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                var inCart = 0;
                (cart.items || []).forEach(function (item) {
                    if (String(item.variant_id) === String(variant.id)) inCart += item.quantity;
                });
                if (inCart + qty <= variant.maxQty) return { ok: true };
                if (inCart >= variant.maxQty) {
                    return { ok: false, message: 'You already have all ' + variant.maxQty + ' available in your cart.' };
                }
                var msg = 'Only ' + variant.maxQty + ' left in stock' + (inCart > 0 ? ' — you already have ' + inCart + ' in your cart.' : '.');
                return { ok: false, message: msg };
            })
            .catch(function () { return { ok: true }; }); // /cart.js недоступен — пусть решает сервер
    }

    function addToCart() {
        if (adding || !selectedVariantId) return;
        var variant = findVariant(selectedVariantId);
        if (!variant || !variant.available) return;

        adding = true;
        var addBtn = popup.querySelector('.or-qvp__add');
        var originalText = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
        popup.querySelector('.or-qvp__error').classList.remove('is-visible');

        var item = { id: parseInt(selectedVariantId, 10), quantity: 1 };
        // Полный тайтл варианта видимым свойством в корзину (как на PDP, Этап 3)
        if (variant.fullTitle) item.properties = { 'Variant': variant.fullTitle };

        var restoreButton = function () {
            adding = false;
            addBtn.disabled = false;
            addBtn.textContent = originalText;
        };

        validateStock(variant, item.quantity).then(function (check) {
            if (!check.ok) {
                showError(check.message);
                restoreButton();
                return;
            }

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [item] })
            })
            .then(function (response) {
                if (!response.ok) {
                    // 422 отдаёт JSON с description; 5xx может отдать HTML — тогда общий текст
                    return response.json().catch(function () { return {}; }).then(function (errData) {
                        throw new Error(errData.description || '');
                    });
                }
                return response.json();
            })
            .then(function () {
                closePopup();
                document.dispatchEvent(new CustomEvent('cart:updated'));
                setTimeout(function () {
                    if (window.openCartPopup) window.openCartPopup();
                }, 500);
            })
            .catch(function (error) {
                console.error('QVP add to cart error:', error);
                showError(error && error.message ? error.message : null);
            })
            .finally(restoreButton);
        });
    }

    // Кнопка "Add to Cart" мульти-вариантной карточки
    document.addEventListener('click', function (e) {
        if (!e.target.closest) return;
        var trigger = e.target.closest('[data-or-qvp-open]');
        if (!trigger) return;

        e.preventDefault();
        e.stopPropagation();

        var card = trigger.closest('[data-or-qvp-card]') || trigger.closest('.or-main-product-card');
        var dataEl = card && card.querySelector('script[data-or-qvp-data]');
        if (!dataEl) return;

        try {
            openPopup(JSON.parse(dataEl.textContent));
        } catch (err) {
            console.error('QVP: invalid variant data JSON', err);
        }
    }, true);
})();
